<script>
import store from '../store/index.js';
export default {
    data() {
        return {
          title: '点赞中国',
          citys: store.citys,
          baseUrl: 'https://x.autoimg.cn/landingpage/activity/map/',
          citysMap: {
              220100 : 'map_changchun.png', //长春
              210100 : 'map_shenyang.png', // 沈阳
              130300 : 'map_qhd.png', //秦皇岛
              120100 : 'map_tianjin.png', // 天津
              140100 : 'map_taiyuan.png', //太原
              130100 : 'map_shijiazhuang.png', // 石家庄
              370100 : 'map_jinan.png', // 济南
              371100 : 'map_rizhao.png', // 日照
              610100 : 'map_xian.png', // 西安
              410100 : 'map_zhengzhou.png', //郑州
              340100 : 'map_hefei.png', // 合肥
              320100 : 'map_nanjing.png', // 南京
              511300 : 'map_nanchong.png', // 南充
              420500 : 'map_yichang.png', // 宜昌
              360100 : 'map_nanchang.png', // 南昌
              330100 : 'map_hangzhou.png',  // 杭州
              500100 : 'map_chongqing.png', // 重庆
              520300 : 'map_zunyi.png', // 遵义
              430100 : 'map_changsha.png', //   长沙
              350100 : 'map_fuzhou.png' // 福州
          }
        }
	},
	computed: {
       imgSrc() {
           const cityId = parseInt(this.cityId);
           if(this.citys.indexOf(cityId) > -1 && this.citysMap[cityId]) {
               return this.baseUrl + this.citysMap[cityId];
           } else {
               return this.baseUrl + 'map_default.png'
           }
       },
       cityId() {
           return store.form.position.cityId;
       }

	},
	mounted() {
	},
	watch: {
		
	},
	methods: {
    }
}
</script>

<template>
<div class="wrap">
    <div class="title">
        {{title}}
    </div>
    <div class="main">
        <div class="imgbox">
            <img :src="imgSrc" />
        </div>
        <div class="shuoming">
            <p class="tit">活动说明：</p>
            <p class="content">
                活动概述：在HS5上市一周年到来之际指定全国20个城市，举办“点赞中国”自驾游活动。<br>
                活动时间：5月30日、5月31日、6月6日、6月7日 <br>
                活动地点：指定全国20个城市<br>
                补充说明：实际路线以活动当天安排为准
            </p>
        </div>
    </div>
</div>
</template>
<style lang="stylus" scoped>
.wrap
    margin 0 0.75rem
    .title
        margin 0 auto
        font-size 0
        width 10.67rem
        height 4.16rem
        background url('../../assets/title_dzzg_bg.png') no-repeat
        background-size contain
    .main
        height 21.76rem
        background #ffffff
        border-radius 0.53rem
        text-align center
        overflow hidden
        .imgbox 
            margin 0.64rem;
            height 12.69rem
            img 
                width 100%
        .shuoming
            padding 0.64rem
            text-align left
            font-size:0.64rem;
            .tit
                font-family:PingFangSC-Semibold,PingFang SC;
                font-weight:600;
                color:rgba(51,51,51,1);
                line-height:1rem;
            .content
                font-family PingFangSC-Regular,PingFang SC
                font-weight 400
                color rgba(51,51,51,1)
                line-height 1.07rem

</style>